var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps-bar"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:step.id,staticClass:"steps-bar__item",class:{
      'steps-bar__item--active': step.id === _vm.active_id,
      'steps-bar__item--completed': _vm.is_completed(step.id),
      'steps-bar__item--disabled': !_vm.is_enabled(step.id),
      'steps-bar__item--clickable': _vm.allow_navigation && _vm.is_enabled(step.id),
    },on:{"click":function($event){return _vm.handle_click(step)}}},[(_vm.is_completed(step.id))?_c('vb-icon',{staticClass:"steps-bar__symbol",attrs:{"name":'check',"color":'ffffff',"size":16}}):_c('span',{staticClass:"steps-bar__symbol"},[_vm._v(_vm._s(index + 1))]),_c('span',{staticClass:"steps-bar__label"},[_vm._v(_vm._s(step.name))]),(index !== _vm.steps.length - 1)?_c('span',{class:{
        'steps-bar__line': true,
        'steps-bar__line--completed': _vm.is_completed(step.id),
      }}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }